/**
 * cubic's own installations: 58867123 is mrge-io production and 83334443 is mrge-io local. They
 * are listed by installation because their billing account has a different id in each
 * environment's database.
 */
const CUBIC_INSTALLATION_IDS: readonly number[] = [58867123, 83334443];

export function isCubicInstallation(installationId: number): boolean {
  return CUBIC_INSTALLATION_IDS.includes(installationId);
}
